























import { SfCheckbox } from '~/components/StorefrontUi';
import {
  defineComponent, ref, PropType, watch, onMounted,
} from '@nuxtjs/composition-api';
import useShipping from '~/modules/checkout/composables/useShipping';
import { debounce } from 'lodash-es';
import {
  addressFromApiToForm,
} from '~/helpers/checkout/address';

export default defineComponent({
  name: 'AdditionalInfo',
  components: {
    SectionHeading: () => import(/* webpackPrefetch: true */ '~/modules/checkout/components/SectionHeading.vue'),
    SfCheckbox,
  },
  props: {
    value: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup() {
    const text = ref('');
    const isOpen = ref(!!text.value);

    const {
      load: loadShipping,
      save: saveShipping,
    } = useShipping();

    const handleAdditionalInfoChange = debounce(async () => {
      const oldData = addressFromApiToForm(await loadShipping());
      const newData = { ...oldData, customerNotes: text.value };
      newData.apartment = newData.apartment ? `${newData.building} / ${newData.apartment}` : newData.building;
      delete newData.building;
      await saveShipping({ shippingDetails: newData });
    }, 3000);

    watch(text, (newValue) => {
      if (newValue) isOpen.value = true;
    });

    onMounted(async () => {
      const shippingInfo = await loadShipping();
      if (shippingInfo?.customer_notes) {
        text.value = shippingInfo.customer_notes;
      }
    });
    return { isOpen, text, handleAdditionalInfoChange };
  },
});
